/**
 * Os destinos oficiais da marca, num lugar só.
 *
 * O rodapé do web e a página de links (`/links`, a que ocupa a bio do
 * Instagram) apontavam para o mesmo Instagram e o mesmo WhatsApp escritos à
 * mão em telas diferentes — trocar o número virava caçada. Mora no core, e não
 * no app, porque dado de marca serve as três plataformas mesmo quando a tela é
 * só-web.
 *
 * Destino de fora é absoluto; destino de dentro começa com "/" para o
 * `withAttribution` do web saber quem é quem.
 */
import type { BrandLink, BrandLinkKey } from "./links.types";
import { BRAND_LINKS_COPY } from "./links.copy";

export type { BrandLink, BrandLinkKey };

/** O número do suporte em E.164, sem "+": é o formato que o `wa.me` aceita. */
export const SUPPORT_WHATSAPP_E164 = "558131973422";

/** O mesmo número como gente lê. O teste amarra os dois. */
export const SUPPORT_WHATSAPP_DISPLAY = "(81) 3197-3422";

export const SUPPORT_EMAIL = "suporte@tamiapp.com";

export const BRAND_LINKS = {
  site: { get label() { return BRAND_LINKS_COPY.site; }, href: "/" },
  signUp: { get label() { return BRAND_LINKS_COPY.signUp; }, href: "/sign-up" },
  instagram: {
    get label() { return BRAND_LINKS_COPY.instagram; },
    href: "https://www.instagram.com/tamiapp.br",
  },
  youtube: {
    get label() { return BRAND_LINKS_COPY.youtube; },
    href: "https://www.youtube.com/@eusouat%C3%A3miapp",
  },
  guide: {
    get label() { return BRAND_LINKS_COPY.guide; },
    href: "https://www.youtube.com/@eusouat%C3%A3miapp/videos",
  },
  supportWhatsApp: {
    label: SUPPORT_WHATSAPP_DISPLAY,
    href: `https://wa.me/${SUPPORT_WHATSAPP_E164}`,
  },
  supportEmail: { label: SUPPORT_EMAIL, href: `mailto:${SUPPORT_EMAIL}` },
} as const satisfies Record<BrandLinkKey, BrandLink>;
